import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LAYOUT_THEME } from '@shared/di/layout-theme.token';

@Component({
  selector: 'app-logo-component',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <img [src]="src()" alt="K-HERO" />
  `,
  styleUrl: './logo.component.scss'
})
export class LogoComponent {
  private readonly layoutTheme = inject(LAYOUT_THEME);

  readonly src = computed(() =>
    this.layoutTheme.isDarkTheme()
      ? 'assets/images/logos/Logo_K-HERO_Full_White.svg'
      : 'assets/images/logos/Logo_K-HERO.svg'
  );
}
